import { ENV } from "../utils";

export class Division {
  baseApi = ENV.BASE_API;

  async getDivisions(accessToken, active = true) {
    const url = `${this.baseApi}/divisions?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createDivision(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-division`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateDivision(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-division/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteDivision(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-division/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
